import { render } from "./previewDialog.vue?vue&type=template&id=117b97e5&scoped=true&lang=pug"
import script from "./previewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./previewDialog.vue?vue&type=script&setup=true&lang=js"

import "./previewDialog.vue?vue&type=style&index=0&id=117b97e5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-117b97e5"

export default script